const type = ['sccuss', 'err', 'over', 'carry']


const typeCode = {
  'SIGNED': type[0],
  1: type[0],
  4: type[3],
  5: type[3],
  9: type[2],
  'EXP_CAL_STATUS': type[1],
  'FAIL_CREDIT': type[1], // 授信失败
}

const textType = (status) => {
  return typeCode[status]
}

export default textType;